'use client';

import ArrowLeft2424 from '@svg/main/arrow_left_24_24.svg';
import ArrowRight2424 from '@svg/main/arrow_right_24_24.svg';

export default function CuratedTripsSlideButtons({ targetId }: { targetId: string }) {
  return (
    <>
      <button
        id={`${targetId}-left-button`}
        className='absolute z-10 hidden bg-white border border-gray-200 rounded-full w-26pxr h-26pxr'
        style={{
          boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.05)',
          top: 'calc(50% - 24px)',
          left: 5,
        }}
        onClick={(e) => {
          const $horizontalList = e.currentTarget.parentElement;
          const currentLeft = e.currentTarget.parentElement?.scrollLeft ?? 0;
          $horizontalList?.scrollTo({
            left: currentLeft - ((e.currentTarget.parentElement?.clientWidth ?? 0) / 3) * 2,
            behavior: 'smooth',
          });
        }}
      >
        <ArrowLeft2424 className='scale-50' />
      </button>
      <button
        id={`${targetId}-right-button`}
        className='absolute z-10 hidden bg-white border border-gray-200 rounded-full w-26pxr h-26pxr'
        style={{
          boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.05)',
          top: 'calc(50% - 24px)',
          right: 5,
        }}
        onClick={(e) => {
          const $horizontalList = e.currentTarget.parentElement;
          const currentLeft = e.currentTarget.parentElement?.scrollLeft ?? 0;
          $horizontalList?.scrollTo({
            left: currentLeft + ((e.currentTarget.parentElement?.clientWidth ?? 0) / 3) * 2,
            behavior: 'smooth',
          });
        }}
      >
        <ArrowRight2424 className='scale-50' />
      </button>
    </>
  );
}
